(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[776],{

/***/ 254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var BlogsCategoryBar = function(param) {
    var categories = param.categories, onClick = param.onClick, resetHandler = param.resetHandler, selected = param.selected, params = param.params;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "collapse d-xl-block w-100",
        id: "collapsibleBlogCategories",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "collapsibleBlogCategories d-block d-xl-flex",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "category_0",
                    className: "d-none d-xl-flex align-items-center active activetopic",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "topic",
                        children: "TOPICS"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: "category_1",
                    className: router.pathname === "/blogs" ? "mo-active category" : "category",
                    onClick: resetHandler,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: params.category && params.subcategory ? encodeURI("https://assets.alanvidyushbaptist.com/icons/".concat(params.subcategory, " White.png")) : params.category ? encodeURI("https://assets.alanvidyushbaptist.com/icons/".concat(params.category, " White.png")) : "https://assets.alanvidyushbaptist.com/icons/Blog_White.png",
                            alt: "All_Blogs",
                            className: "mt-auto mb-auto category",
                            height: "30px",
                            width: "30px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: "ALL"
                        })
                    ]
                }),
                categories && categories.map(function(category, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "category_" + category.name,
                        onClick: function() {
                            return onClick(category.name);
                        },
                        className: category.name === selected ? "category" : "category",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#collapsibleBlogCategories",
                        "aria-expanded": "false",
                        "aria-controls": "collapsibleBlogCategories",
                        children: [
                            category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: encodeURI("https://assets.alanvidyushbaptist.com/icons/".concat(category.name, " White.png")),
                                alt: category.name + "_icon",
                                className: "mt-auto mb-auto",
                                height: "30px",
                                width: "30px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "m-xl-auto",
                                children: category.name
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogsCategoryBar);


/***/ }),

/***/ 3549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var BlogHeader = function(param) {
    var blogs = param.blogs;
    return blogs && blogs[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "position-relative blogBanner",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: blogs[0].headerImage && blogs[0].headerImage[0].image,
                className: "w-100",
                alt: blogs[0].headerImage && blogs[0].headerImage[0].name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "imageOverlay",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fo-52 fw-600 text-center mfo-20",
                        children: blogs[0].title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center mt-3 mt-md-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blogs/" + blogs[0].slug,
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "btn showMoreButton",
                                children: "READ MORE"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogHeader);


/***/ }),

/***/ 2999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9815);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _cards_BlogCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(505);
/* harmony import */ var _utils_urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1510);
/* harmony import */ var _utils_blogsHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4643);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6968);










var BlogGrid = function(param) {
    var category = param.category;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), blogs = ref2[0], setBlogs = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isCompleted = ref3[0], setCompleted = ref3[1];
    var getNextBlogs = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var url, res;
            return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        url = _utils_urls__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get_blogApi.url */ .Z.get_blogApi.url + "?category=" + category + "&index=" + page * 6 + "&limit=" + 6;
                        setLoading(true);
                        _ctx.next = 5;
                        return axios__WEBPACK_IMPORTED_MODULE_6___default().get(encodeURI(url));
                    case 5:
                        res = _ctx.sent;
                        if (page === 0) {
                            setBlogs(res.data);
                        } else {
                            console.log(res.data);
                            if (res.data.length > 0) {
                                setBlogs((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(blogs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(res.data)));
                            } else {
                                setCompleted(true);
                            }
                        }
                        setLoading(false);
                        setPage(function(prev) {
                            return prev + 1;
                        });
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                        setLoading(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function getNextBlogs() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_utils_blogsHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetch */ .he)(_utils_urls__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get_blogApi.url */ .Z.get_blogApi.url + "?minimal=true&index=0&limit=6" + "&category=" + category).then(function(data) {
            if (data) {
                setBlogs((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(blogs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(data)));
            }
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                className: "blogCategoryTitle fo-34 mt-5 fw-700",
                children: category
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "row m-0 mt-3",
                id: "displayAllBlogs",
                children: blogs.map(function(blog, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_cards_BlogCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        blog: blog
                    }, category + "_grid_" + index);
                })
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    animation: "border"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center mt-5 mb-5",
                children: isCompleted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "fo-18 fw-600 text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: "No more blogs"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "btn showMoreButton",
                    onClick: getNextBlogs,
                    children: "Show More"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogGrid);


/***/ }),

/***/ 505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Card_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7539);
/* harmony import */ var _Card_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Card_module_css__WEBPACK_IMPORTED_MODULE_2__);



var BlogCard = function(param) {
    var blog = param.blog, _transformation = param.transformation, transformation = _transformation === void 0 ? false : _transformation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "col-6 col-lg-4 mb-4 p-md-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/blogs/" + blog.slug,
                target: "_blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: transformation && blog.transformation_image ? blog.transformation_image : blog.headerImage[0].image,
                        className: "w-100 ".concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().cursorPointer)),
                        alt: blog.title
                    })
                })
            }),
            !transformation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/blogs/" + blog.slug,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().listed_blog_title), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fo20), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fw600), " text-center ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().mfo13), " mb-3"),
                                children: blog.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().listed_blog_summary), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fo14), " ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().fw400), " text-center ").concat((_Card_module_css__WEBPACK_IMPORTED_MODULE_2___default().mfo11)),
                        children: blog.summary
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 2698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ rootCategories; },
/* harmony export */   "S": function() { return /* binding */ blogCatandSub; }
/* harmony export */ });
var rootCategories = [
    {
        name: "Fitness"
    },
    {
        name: "Nutrition",
        image: "/assets/icons/Nutrition Concepts White.png"
    },
    {
        name: "Education",
        image: "/assets/icons/Education White.png"
    },
    {
        name: "Psychology",
        image: "/assets/icons/Psychology Concepts White.png"
    }, 
];
var blogCatandSub = {
    Fitness: [
        {
            name: "Weight Loss",
            image: "/assets/icons/Weight Loss White.png"
        },
        {
            name: "Muscle Gain",
            image: "/assets/icons/Muscle Gain White.png"
        },
        {
            name: "Body Recomposition",
            image: "/assets/icons/Body Recomposition White.png"
        },
        {
            name: "Sports Performance",
            image: "/assets/icons/Sports Performance White.png"
        },
        {
            name: "Fitness Modelling",
            image: "/assets/icons/Fitness Modelling White.png"
        },
        {
            name: "Fitness Myths",
            image: "/assets/icons/Fitness Myths White.png"
        },
        {
            name: "Postpartum",
            image: "/assets/icons/Postpartum White.png"
        }, 
    ],
    Nutrition: [
        {
            name: "Weight Loss",
            image: "/assets/icons/Weight Loss White.png"
        },
        {
            name: "Weight Gain",
            image: "/assets/icons/Weight Gain White.png"
        },
        {
            name: "Nutrition Concepts",
            image: "/assets/icons/Nutrition Concepts White.png"
        },
        {
            name: "Recipes",
            image: "/assets/icons/Recipes White.png"
        },
        {
            name: "Nutrition Myths",
            image: "/assets/icons/Nutrition Myths White.png"
        }, 
    ],
    Education: [
        {
            name: "Career",
            image: "/assets/icons/Career White.png"
        },
        {
            name: "Skills",
            image: "/assets/icons/Skills White.png"
        }, 
    ],
    Psychology: [
        {
            name: "Sex",
            image: "/assets/icons/Sex White.png"
        },
        {
            name: "Relationships",
            image: "/assets/icons/Relationships White.png"
        },
        {
            name: "Communication",
            image: "/assets/icons/Communication White.png"
        },
        {
            name: "Psychology Concepts",
            image: "/assets/icons/Psychology Concepts White.png"
        },
        {
            name: "Philosophy",
            image: "/assets/icons/Philosophy White.png"
        },
        {
            name: "Spirituality",
            image: "/assets/icons/Spirituality White.png"
        }, 
    ],
    Finance: [
        {
            name: "Taxation",
            image: "/assets/icons/Taxation White.png"
        },
        {
            name: "Investment",
            image: "/assets/icons/Investment Yellow.png"
        },
        {
            name: "Business",
            image: "/assets/icons/Business White.png"
        },
        {
            name: "Commerce",
            image: "/assets/icons/Commerce White.png"
        },
        {
            name: "Economics",
            image: "/assets/icons/Economics White.png"
        }, 
    ]
};


/***/ }),

/***/ 4643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ fetchBlogs; },
/* harmony export */   "Vn": function() { return /* binding */ fetchCategoryBlogs; },
/* harmony export */   "he": function() { return /* binding */ fetch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _urls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1510);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);





var makeRequest = function(url) {
    axios__WEBPACK_IMPORTED_MODULE_2___default().get(encodeURI(url)).then(function(res) {
        if (window != undefined) {
            window.localStorage.setItem(url, JSON.stringify(res.data));
            return res.data;
        }
    });
};
var fetchBlogs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var subcategory, category, search, page, limit, url, res, _args = arguments;
        return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    subcategory = param.subcategory, category = param.category, search = param.search, page = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0, limit = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 6;
                    url = _urls__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get_blogApi.url */ .Z.get_blogApi.url + "?index=0&minimal=true";
                    if (search) url = url + "&limit=100&searchQuery=" + search;
                    else if (category && subcategory) {
                        url = url + "&limit=6&category=".concat(category, "&subcategory=").concat(subcategory);
                    } else if (category) {
                        url = url + "&limit=6&category=".concat(category);
                    } else {
                        url = _urls__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get_blogApi.url */ .Z.get_blogApi.url + "?minimal=true&index=" + page * limit + "&limit=" + limit;
                    }
                    if (!(window != undefined && window.localStorage.getItem(encodeURI(url)))) {
                        _ctx.next = 8;
                        break;
                    }
                    makeRequest(encodeURI(url));
                    return _ctx.abrupt("return", JSON.parse(window.localStorage.getItem(encodeURI(url))));
                case 8:
                    _ctx.next = 10;
                    return axios__WEBPACK_IMPORTED_MODULE_2___default().get(encodeURI(url));
                case 10:
                    res = _ctx.sent;
                    if (window != undefined) window.localStorage.setItem(encodeURI(url), JSON.stringify(res.data));
                    return _ctx.abrupt("return", res.data);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBlogs(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCategoryBlogs = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(categories) {
        var data, i, category, blogs;
        return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = {};
                    if (!(window != undefined && window.localStorage.getItem("categoryData"))) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", JSON.parse(window.localStorage.getItem("categoryData")));
                case 3:
                    i = 0;
                case 4:
                    if (!(i < categories.length)) {
                        _ctx.next = 13;
                        break;
                    }
                    category = categories[i];
                    _ctx.next = 8;
                    return fetchBlogs({
                        category: category.name
                    });
                case 8:
                    blogs = _ctx.sent;
                    data[category.name] = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(blogs);
                case 10:
                    i++;
                    _ctx.next = 4;
                    break;
                case 13:
                    if (window != undefined) {
                        window.localStorage.setItem("categoryData", JSON.stringify(data));
                    }
                    return _ctx.abrupt("return", data);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchCategoryBlogs(categories) {
        return _ref.apply(this, arguments);
    };
}();
var fetch = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        var res;
        return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(window != undefined && window.localStorage.getItem(encodeURI(url)))) {
                        _ctx.next = 5;
                        break;
                    }
                    makeRequest(encodeURI(url));
                    return _ctx.abrupt("return", JSON.parse(window.localStorage.getItem(encodeURI(url))));
                case 5:
                    _ctx.next = 7;
                    return axios__WEBPACK_IMPORTED_MODULE_2___default().get(encodeURI(url));
                case 7:
                    res = _ctx.sent;
                    if (window != undefined) window.localStorage.setItem(encodeURI(url), JSON.stringify(res.data));
                    return _ctx.abrupt("return", res.data);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetch(url) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
var baseUrl = "https://itchy-blue-seagull.cyclic.app";
// export const domainUrl = "https://optimumwellness.in";
// export const baseUrl = `http://localhost:8081`;
// http://localhost:8081
var urlSet = {
    // Blogs
    get_blogApi: {
        // Get blogs
        url: baseUrl + "/api/v1/blogs",
        method: "GET"
    },
    post_blogApi: {
        // Add a new blog
        url: baseUrl + "/api/v1/blogs/",
        method: "POST"
    },
    edit_blogApi: {
        // Edit blog
        url: baseUrl + "/api/v1/blogs/",
        method: "PATCH"
    },
    delete_blogApi: {
        // Delete a blog
        url: baseUrl + "/api/v1/blogs/",
        method: "DELETE"
    },
    get_AuthorblogApi: {
        // Get blogs of an author
        url: baseUrl + "/api/v1/blogs/author/",
        method: "GET"
    },
    get_featuredblogApi: {
        // Get featured blogs
        url: baseUrl + "/api/v1/blogs/featured",
        method: "GET"
    },
    data_intervalApi: {
        // set data interval
        url: baseUrl + "/api/v1/blogs/updateDataInterval",
        method: "PATCH"
    },
    // Admin
    adminLoginApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/login",
        method: "POST"
    },
    adminUpdateApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/update",
        method: "PATCH"
    },
    // Admin blogs
    add_blog_to_featuredApi: {
        // Add to featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "PATCH"
    },
    delete_blog_from_featuredApi: {
        // Delete from featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "DELETE"
    },
    // Admin services
    viewServicesApi: {
        // To get services
        url: baseUrl + "/api/v1/admin/service/",
        method: "GET"
    },
    getMainServiceApi: {
        // To get services based on level
        url: baseUrl + "/api/v1/admin/service",
        method: "GET"
    },
    addServiceApi: {
        // To add new service
        url: baseUrl + "/api/v1/admin/service",
        method: "POST"
    },
    deleteServiceApi: {
        // To delete services
        url: baseUrl + "/api/v1/admin/service/",
        method: "DELETE"
    },
    editServicesApi: {
        // Update service names
        url: baseUrl + "/api/v1/admin/service/",
        method: "PATCH"
    },
    // Admin offers
    editOffersApi: {
        // Update offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "PATCH"
    },
    deleteOffersApi: {
        // Delete offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "DELETE"
    },
    // Admin coupons
    viewCouponsApi: {
        // Get all coupons
        url: baseUrl + "/api/v1/admin/coupon",
        method: "GET"
    },
    addCouponsApi: {
        // Add new coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "POST"
    },
    deleteCouponsApi: {
        // Delete a coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "DELETE"
    },
    // Payments
    applyCouponApi: {
        // Apply coupon
        url: baseUrl + "/api/v1/payment/applyCoupon",
        method: "POST"
    },
    paymentApi: {
        // Create payment order id
        url: baseUrl + "/api/v1/payment/generateReceipt",
        method: "POST"
    },
    verifyPaymentApi: {
        // Verify payments status after razorpay
        url: baseUrl + "/api/v1/payment/verifyPayment",
        method: "POST"
    },
    // Admin transactions
    viewTransactionsApi: {
        // View all transactions
        url: baseUrl + "/api/v1/transaction",
        method: "GET"
    },
    addTransactionsApi: {
        // Add transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "POST"
    },
    updateTransactionsApi: {
        // Update transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "PATCH"
    },
    deleteTransactionsApi: {
        // Delete transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "DELETE"
    },
    // Add employees
    viewEmployeesApi: {
        // Get all employees
        url: baseUrl + "/api/v1/employees/?index=0&limit=50",
        method: "GET"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (urlSet);


/***/ }),

/***/ 7539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listed_blog_title":"Card_listed_blog_title__A_axn","listed_blog_summary":"Card_listed_blog_summary__UyN11"};

/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 6968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);




const Spinner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  variant,
  animation,
  size,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'spinner');
  const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
  });
});
Spinner.displayName = 'Spinner';
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);

/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 998:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"category":"Fitness","subcategory":null,"text":"Ready, Sweat, Go!"},{"category":"Nutrition","subcategory":null,"text":"I removed all the bad food from my house. It tasted delicious!"},{"category":"Education","subcategory":null,"text":"It\'s the mother of leadership!"},{"category":"Psychology","subcategory":null,"text":"The human mind is not a terribly logical or consistent place."},{"category":"Finance","subcategory":null,"text":"Do not save what is left after spending, but spend what is left after saving."},{"category":"Fitness","subcategory":"Weight Loss","text":"Count both memories and calories!"},{"category":"Fitness","subcategory":"Muscle Gain","text":"Don\'t forget your protein!"},{"category":"Fitness","subcategory":"Body Recomposition","text":"EAT. LIFT. SLEEP. REPEAT."},{"category":"Fitness","subcategory":"Sports Performance","text":"There\'s winning and learning. No losing."},{"category":"Fitness","subcategory":"Fitness Modelling","text":"Successful people do daily what others do occasionally!"},{"category":"Fitness","subcategory":"Fitness Myths","text":"Question everything in the search for evidence!"},{"category":"Fitness","subcategory":"Postpartum","text":"Custom text"},{"category":"Nutrition","subcategory":"Weight Loss","text":"I thought about losing weight once, but I don\'t like losing."},{"category":"Nutrition","subcategory":"Weight Gain","text":" I gained weight by snackcident!"},{"category":"Nutrition","subcategory":"Nutrition Concepts","text":"Let\'s build them concepts!"},{"category":"Nutrition","subcategory":"Recipes","text":"Did someone say food?"},{"category":"Nutrition","subcategory":"Nutrition Myths","text":"Let\'s bust them myths!"},{"category":"Education","subcategory":"Career","text":" Finding your passion is a key to success!"},{"category":"Education","subcategory":"Skills","text":"Repetition is the mother of skill!"},{"category":"Psychology","subcategory":"Sex","text":"Sexy Imagination, not a Dirty Mind."},{"category":"Psychology","subcategory":"Relationships","text":"Does it really take exactly two to tangle?"},{"category":"Psychology","subcategory":"Communication","text":"It involves listening too."},{"category":"Psychology","subcategory":"Psychology Concepts","text":"The only normal people are the ones you don\'t know very well."},{"category":"Psychology","subcategory":"Philosophy","text":"Conquer yourself first!"},{"category":"Psychology","subcategory":"Spirituality","text":"The world is full of magical things waitin for our senses to grow sharper!"},{"category":"Finance","subcategory":"Taxation","text":"Income Tax Returns are perhaps the most imaginative fiction being written today."},{"category":"Finance","subcategory":"Investment","text":"Successful investing is about managing risk, not avoiding it."},{"category":"Finance","subcategory":"Business","text":"If oppurtunity doesn\'t knock, build a door!"},{"category":"Finance","subcategory":"Commerce","text":"Always deliver more than expected!"},{"category":"Finance","subcategory":"Economics","text":"Human wants are unlimited."}]');

/***/ })

}]);